import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { fmtDay } from "@/lib/format";
import { Logo, Spinner } from "@/components/rp";

export default function ImpresaPage() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [bad, setBad] = useState("");
  useEffect(() => { api.get(`/public/impresa/${token}`).then((r) => setD(r.data)).catch((e) => setBad(errMsg(e))); }, [token]);
  return (
    <div className="min-h-screen bg-white px-6 py-10">
      <div className="max-w-2xl mx-auto" data-testid="impresa-page">
        <Logo className="h-8 mb-8" />
        {bad && <p className="text-[#DC3545]" data-testid="impresa-invalid">{bad}</p>}
        {!d && !bad && <Spinner />}
        {d && (
          <>
            <p className="rp-label">Cronoprogramma RP Home</p>
            <h1 className="text-3xl font-semibold tracking-tight mt-2 mb-6">{d.impresa}</h1>
            {!d.rows.length && <p className="text-sm text-[#757575]">Nessuna lavorazione in programma.</p>}
            <div className="space-y-3">
              {d.rows.map((r, i) => (
                <div key={i} className="rounded-2xl border border-[#EBEBEB] p-4" data-testid={`impresa-row-${i}`}>
                  <p className="font-semibold">{fmtDay(r.start)} → {fmtDay(r.end)} · {r.lavorazione}</p>
                  <p className="text-sm text-[#757575]">{r.code} · {r.title}{r.address && ` · ${r.address}`}</p>
                  {r.note && <p className="text-sm mt-1">{r.note}</p>}
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
